import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '@/assets/logo.png';
const _hoisted_1 = {
  class: "min-h-screen flex"
};
const _hoisted_2 = {
  class: "flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8 py-12"
};
const _hoisted_3 = {
  class: "w-full max-w-md space-y-8"
};
const _hoisted_4 = {
  class: "text-center"
};
const _hoisted_5 = {
  class: "mt-2 text-slate-600"
};
const _hoisted_6 = {
  class: "relative"
};
const _hoisted_7 = {
  class: "relative"
};
const _hoisted_8 = ["type"];
const _hoisted_9 = ["aria-label", "aria-pressed"];
const _hoisted_10 = {
  key: 0,
  class: "h-5 w-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_11 = {
  key: 1,
  class: "h-5 w-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_12 = {
  class: "flex items-center justify-between"
};
const _hoisted_13 = {
  class: "flex items-center"
};
const _hoisted_14 = ["disabled"];
const _hoisted_15 = {
  key: 0,
  class: "absolute inset-y-0 left-0 pl-3 flex items-center"
};
const _hoisted_16 = {
  key: 1,
  class: "mt-8 space-y-6"
};
const _hoisted_17 = {
  class: "space-y-3"
};
const _hoisted_18 = ["disabled", "onClick"];
const _hoisted_19 = {
  class: "flex-shrink-0 w-10 h-10 bg-primary-100 text-primary-600 rounded-lg flex items-center justify-center font-semibold group-hover:bg-primary-200 transition-colors"
};
const _hoisted_20 = {
  class: "flex-1 text-left"
};
const _hoisted_21 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_22 = {
  key: 0,
  class: "text-xs text-slate-500 mt-0.5"
};
const _hoisted_23 = {
  key: 0,
  class: "flex items-center justify-center gap-2 text-sm text-slate-500"
};
const _hoisted_24 = {
  class: "relative"
};
const _hoisted_25 = {
  class: "flex gap-3"
};
const _hoisted_26 = {
  class: "relative flex-1"
};
const _hoisted_27 = ["disabled"];
const _hoisted_28 = {
  key: 0
};
const _hoisted_29 = {
  key: 1
};
const _hoisted_30 = {
  key: 2
};
const _hoisted_31 = {
  class: "relative"
};
const _hoisted_32 = ["type"];
const _hoisted_33 = ["aria-label", "aria-pressed"];
const _hoisted_34 = {
  key: 0,
  class: "h-5 w-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_35 = {
  key: 1,
  class: "h-5 w-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_36 = {
  class: "relative"
};
const _hoisted_37 = ["type"];
const _hoisted_38 = ["aria-label", "aria-pressed"];
const _hoisted_39 = {
  key: 0,
  class: "h-5 w-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_40 = {
  key: 1,
  class: "h-5 w-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_41 = {
  key: 0,
  class: "text-sm text-red-600"
};
const _hoisted_42 = {
  key: 1,
  class: "text-sm text-red-600"
};
const _hoisted_43 = ["disabled"];
const _hoisted_44 = {
  key: 0,
  class: "absolute inset-y-0 left-0 pl-3 flex items-center"
};
import { ref, reactive, computed, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { useUserStore } from '@/stores/user';
import { sendResetSmsCode, resetPasswordBySms } from '@/api/auth';
const REMEMBER_KEY = 'rememberedPhone';
export default {
  __name: 'Login',
  setup(__props) {
    const router = useRouter();
    const userStore = useUserStore();

    // ========== 视图切换 ==========
    const currentView = ref('login'); // 'login' | 'tenant' | 'reset'

    const viewSubtitle = computed(() => {
      if (currentView.value === 'login') return '登录管理后台';
      if (currentView.value === 'tenant') return '选择租户';
      return '重置登录密码';
    });
    function switchToReset() {
      currentView.value = 'reset';
      resetError.value = '';
    }
    function switchToLogin() {
      currentView.value = 'login';
      tenantList.value = [];
      tenantAccountId.value = null;
      resetForm.phone = '';
      resetForm.smsCode = '';
      resetForm.newPassword = '';
      resetForm.confirmPassword = '';
      resetError.value = '';
      countdown.value = 0;
      if (countdownTimer) {
        clearInterval(countdownTimer);
        countdownTimer = null;
      }
    }

    // ========== 登录表单 ==========
    const loading = ref(false);
    const showPassword = ref(false);
    const form = reactive({
      phone: '',
      password: '',
      remember: false
    });

    // ========== 记住我 ==========
    onMounted(() => {
      const saved = localStorage.getItem(REMEMBER_KEY);
      if (saved) {
        form.phone = saved;
        form.remember = true;
      }
    });
    function saveOrClearRemember() {
      if (form.remember) {
        localStorage.setItem(REMEMBER_KEY, form.phone);
      } else {
        localStorage.removeItem(REMEMBER_KEY);
      }
    }

    // ========== 租户选择 ==========
    const tenantList = ref([]);
    const tenantAccountId = ref(null);
    const selectingTenant = ref(false);
    const handleLogin = async () => {
      if (!form.phone) {
        ElMessage.warning('请输入手机号');
        return;
      }
      if (!form.password) {
        ElMessage.warning('请输入密码');
        return;
      }
      loading.value = true;
      try {
        const res = await userStore.doLogin(form.phone, form.password);
        if (res.requireTenantSelection) {
          tenantAccountId.value = res.accountId;
          tenantList.value = res.tenants || [];
          currentView.value = 'tenant';
          saveOrClearRemember();
        } else if (res.forceChangePassword) {
          saveOrClearRemember();
          router.push('/force-change-password');
        } else {
          saveOrClearRemember();
          ElMessage.success('登录成功');
          router.push('/dashboard');
        }
      } catch (error) {
        ElMessage.error(error.message || '登录失败');
      } finally {
        loading.value = false;
      }
    };
    const handleSelectTenant = async tenant => {
      selectingTenant.value = true;
      try {
        const res = await userStore.doSelectTenant(tenantAccountId.value, tenant.tenantId);
        if (res.forceChangePassword) {
          router.push('/force-change-password');
        } else {
          ElMessage.success('登录成功');
          router.push('/dashboard');
        }
      } catch (error) {
        ElMessage.error(error.message || '登录失败');
      } finally {
        selectingTenant.value = false;
      }
    };

    // ========== 重置密码表单 ==========
    const resetForm = reactive({
      phone: '',
      smsCode: '',
      newPassword: '',
      confirmPassword: ''
    });
    const resetError = ref('');
    const resetting = ref(false);
    const showResetPassword = ref(false);
    const showResetConfirmPassword = ref(false);

    // 验证码倒计时
    const countdown = ref(0);
    const sendingCode = ref(false);
    let countdownTimer = null;
    const resetConfirmError = computed(() => {
      return resetForm.confirmPassword !== '' && resetForm.newPassword !== '' && resetForm.confirmPassword !== resetForm.newPassword;
    });
    function startCountdown() {
      countdown.value = 60;
      countdownTimer = setInterval(() => {
        countdown.value--;
        if (countdown.value <= 0) {
          clearInterval(countdownTimer);
          countdownTimer = null;
        }
      }, 1000);
    }
    async function handleSendCode() {
      if (!resetForm.phone) {
        ElMessage.warning('请输入手机号');
        return;
      }
      if (!/^1\d{10}$/.test(resetForm.phone)) {
        ElMessage.warning('请输入正确的手机号');
        return;
      }
      sendingCode.value = true;
      try {
        await sendResetSmsCode(resetForm.phone);
        ElMessage.success('验证码已发送');
        startCountdown();
      } catch (error) {
        ElMessage.error(error.message || '验证码发送失败');
      } finally {
        sendingCode.value = false;
      }
    }
    async function handleResetPassword() {
      resetError.value = '';
      if (!resetForm.phone) {
        resetError.value = '请输入手机号';
        return;
      }
      if (!/^1\d{10}$/.test(resetForm.phone)) {
        resetError.value = '请输入正确的手机号';
        return;
      }
      if (!resetForm.smsCode) {
        resetError.value = '请输入验证码';
        return;
      }
      if (!resetForm.newPassword) {
        resetError.value = '请输入新密码';
        return;
      }
      const password = resetForm.newPassword;
      if (password.length < 6 || password.length > 20) {
        resetError.value = '密码长度必须在6-20位之间';
        return;
      }
      if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(password)) {
        resetError.value = '密码必须包含大小写字母和数字';
        return;
      }
      if (password !== resetForm.confirmPassword) {
        resetError.value = '两次输入的密码不一致';
        return;
      }
      resetting.value = true;
      try {
        await resetPasswordBySms({
          phone: resetForm.phone,
          code: resetForm.smsCode,
          newPassword: resetForm.newPassword
        });
        ElMessage.success('密码重置成功，请使用新密码登录');
        switchToLogin();
      } catch (error) {
        resetError.value = error.message || '重置密码失败';
      } finally {
        resetting.value = false;
      }
    }
    onUnmounted(() => {
      if (countdownTimer) {
        clearInterval(countdownTimer);
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[12] || (_cache[12] = _createElementVNode("div", {
        class: "flex justify-center mb-6"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "Logo",
        class: "w-14 h-14 rounded-xl object-contain"
      })], -1)), _cache[13] || (_cache[13] = _createElementVNode("h1", {
        class: "text-2xl sm:text-3xl font-bold text-slate-900"
      }, "小到大企服平台", -1)), _createElementVNode("p", _hoisted_5, _toDisplayString(viewSubtitle.value), 1)]), currentView.value === 'login' ? (_openBlock(), _createElementBlock("form", {
        key: 0,
        class: "mt-8 space-y-6",
        onSubmit: _withModifiers(handleLogin, ["prevent"])
      }, [_createElementVNode("div", null, [_cache[15] || (_cache[15] = _createElementVNode("label", {
        for: "phone",
        class: "block text-sm font-medium text-slate-700 mb-2"
      }, "手机号", -1)), _createElementVNode("div", _hoisted_6, [_cache[14] || (_cache[14] = _createElementVNode("div", {
        class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
      }, [_createElementVNode("svg", {
        class: "h-5 w-5 text-slate-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
      })])], -1)), _withDirectives(_createElementVNode("input", {
        id: "phone",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.phone = $event),
        name: "phone",
        type: "tel",
        required: "",
        class: "form-search-input",
        placeholder: "请输入手机号"
      }, null, 512), [[_vModelText, form.phone]])])]), _createElementVNode("div", null, [_cache[19] || (_cache[19] = _createElementVNode("label", {
        for: "password",
        class: "block text-sm font-medium text-slate-700 mb-2"
      }, "密码", -1)), _createElementVNode("div", _hoisted_7, [_cache[18] || (_cache[18] = _createElementVNode("div", {
        class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
      }, [_createElementVNode("svg", {
        class: "h-5 w-5 text-slate-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
      })])], -1)), _withDirectives(_createElementVNode("input", {
        id: "password",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.password = $event),
        name: "password",
        type: showPassword.value ? 'text' : 'password',
        required: "",
        class: "form-search-input form-input-with-suffix",
        placeholder: "请输入密码"
      }, null, 8, _hoisted_8), [[_vModelDynamic, form.password]]), _createElementVNode("button", {
        type: "button",
        onClick: _cache[2] || (_cache[2] = $event => showPassword.value = !showPassword.value),
        "aria-label": showPassword.value ? '隐藏密码' : '显示密码',
        "aria-pressed": showPassword.value,
        class: "absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer text-slate-400 hover:text-slate-600 transition-colors"
      }, [showPassword.value ? (_openBlock(), _createElementBlock("svg", _hoisted_10, [...(_cache[16] || (_cache[16] = [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
      }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_11, [...(_cache[17] || (_cache[17] = [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      }, null, -1), _createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
      }, null, -1)]))]))], 8, _hoisted_9)])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_withDirectives(_createElementVNode("input", {
        id: "remember",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.remember = $event),
        name: "remember",
        type: "checkbox",
        class: "form-check"
      }, null, 512), [[_vModelCheckbox, form.remember]]), _cache[20] || (_cache[20] = _createElementVNode("label", {
        for: "remember",
        class: "ml-2 block text-sm text-slate-700 cursor-pointer"
      }, "记住我", -1))]), _createElementVNode("button", {
        type: "button",
        class: "text-sm font-medium text-primary-600 hover:text-primary-500 transition-colors cursor-pointer",
        onClick: switchToReset
      }, "忘记密码?")]), _createElementVNode("div", null, [_createElementVNode("button", {
        type: "submit",
        disabled: loading.value,
        class: "group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-lg text-white bg-primary-700 hover:bg-primary-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-all duration-200 shadow-lg shadow-primary-500/25 hover:shadow-xl hover:shadow-primary-500/30 disabled:opacity-50 disabled:cursor-not-allowed"
      }, [loading.value ? (_openBlock(), _createElementBlock("span", _hoisted_15, [...(_cache[21] || (_cache[21] = [_createElementVNode("svg", {
        class: "animate-spin h-5 w-5 text-primary-300",
        fill: "none",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("circle", {
        class: "opacity-25",
        cx: "12",
        cy: "12",
        r: "10",
        stroke: "currentColor",
        "stroke-width": "4"
      }), _createElementVNode("path", {
        class: "opacity-75",
        fill: "currentColor",
        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      })], -1)]))])) : _createCommentVNode("", true), _createElementVNode("span", {
        class: _normalizeClass({
          'pl-7': loading.value
        })
      }, _toDisplayString(loading.value ? '登录中...' : '登录'), 3)], 8, _hoisted_14)])], 32)) : currentView.value === 'tenant' ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_cache[25] || (_cache[25] = _createElementVNode("div", {
        class: "text-center"
      }, [_createElementVNode("p", {
        class: "text-sm text-slate-500"
      }, "该账号关联了多个租户，请选择要登录的租户")], -1)), _createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tenantList.value, tenant => {
        return _openBlock(), _createElementBlock("button", {
          key: tenant.tenantId,
          type: "button",
          disabled: selectingTenant.value,
          class: "w-full flex items-center gap-4 p-4 border border-slate-200 rounded-lg hover:border-primary-400 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed group",
          onClick: $event => handleSelectTenant(tenant)
        }, [_createElementVNode("div", _hoisted_19, _toDisplayString(tenant.tenantName?.charAt(0) || 'T'), 1), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(tenant.tenantName), 1), tenant.nickname ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(tenant.nickname), 1)) : _createCommentVNode("", true)]), _cache[22] || (_cache[22] = _createElementVNode("svg", {
          class: "w-5 h-5 text-slate-300 group-hover:text-primary-500 transition-colors",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5l7 7-7 7"
        })], -1))], 8, _hoisted_18);
      }), 128))]), selectingTenant.value ? (_openBlock(), _createElementBlock("div", _hoisted_23, [...(_cache[23] || (_cache[23] = [_createElementVNode("svg", {
        class: "animate-spin h-4 w-4",
        fill: "none",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("circle", {
        class: "opacity-25",
        cx: "12",
        cy: "12",
        r: "10",
        stroke: "currentColor",
        "stroke-width": "4"
      }), _createElementVNode("path", {
        class: "opacity-75",
        fill: "currentColor",
        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      })], -1), _createTextVNode(" 登录中... ", -1)]))])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: "text-center"
      }, [_createElementVNode("button", {
        type: "button",
        class: "text-sm font-medium text-primary-600 hover:text-primary-500 transition-colors cursor-pointer",
        onClick: switchToLogin
      }, [...(_cache[24] || (_cache[24] = [_createElementVNode("span", {
        class: "inline-flex items-center gap-1"
      }, [_createElementVNode("svg", {
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M10 19l-7-7m0 0l7-7m-7 7h18"
      })]), _createTextVNode(" 返回登录 ")], -1)]))])])])) : (_openBlock(), _createElementBlock("form", {
        key: 2,
        class: "mt-8 space-y-5",
        onSubmit: _withModifiers(handleResetPassword, ["prevent"])
      }, [_createElementVNode("div", null, [_cache[27] || (_cache[27] = _createElementVNode("label", {
        for: "resetPhone",
        class: "block text-sm font-medium text-slate-700 mb-2"
      }, "手机号", -1)), _createElementVNode("div", _hoisted_24, [_cache[26] || (_cache[26] = _createElementVNode("div", {
        class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
      }, [_createElementVNode("svg", {
        class: "h-5 w-5 text-slate-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
      })])], -1)), _withDirectives(_createElementVNode("input", {
        id: "resetPhone",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => resetForm.phone = $event),
        type: "tel",
        maxlength: "11",
        class: "form-search-input",
        placeholder: "请输入手机号"
      }, null, 512), [[_vModelText, resetForm.phone]])])]), _createElementVNode("div", null, [_cache[29] || (_cache[29] = _createElementVNode("label", {
        for: "smsCode",
        class: "block text-sm font-medium text-slate-700 mb-2"
      }, "验证码", -1)), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_cache[28] || (_cache[28] = _createElementVNode("div", {
        class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
      }, [_createElementVNode("svg", {
        class: "h-5 w-5 text-slate-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
      })])], -1)), _withDirectives(_createElementVNode("input", {
        id: "smsCode",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => resetForm.smsCode = $event),
        type: "text",
        maxlength: "6",
        class: "form-search-input",
        placeholder: "请输入验证码"
      }, null, 512), [[_vModelText, resetForm.smsCode]])]), _createElementVNode("button", {
        type: "button",
        disabled: countdown.value > 0 || sendingCode.value,
        class: _normalizeClass(["flex-shrink-0 px-4 py-3 text-sm font-medium rounded-lg transition-all duration-200 cursor-pointer disabled:cursor-not-allowed", countdown.value > 0 || sendingCode.value ? 'bg-slate-100 text-slate-400 border border-slate-200' : 'bg-primary-50 text-primary-600 border border-primary-200 hover:bg-primary-100']),
        onClick: handleSendCode
      }, [sendingCode.value ? (_openBlock(), _createElementBlock("span", _hoisted_28, "发送中...")) : countdown.value > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(countdown.value) + "s后重试", 1)) : (_openBlock(), _createElementBlock("span", _hoisted_30, "获取验证码"))], 10, _hoisted_27)])]), _createElementVNode("div", null, [_cache[33] || (_cache[33] = _createElementVNode("label", {
        for: "resetPassword",
        class: "block text-sm font-medium text-slate-700 mb-2"
      }, "新密码", -1)), _createElementVNode("div", _hoisted_31, [_cache[32] || (_cache[32] = _createElementVNode("div", {
        class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
      }, [_createElementVNode("svg", {
        class: "h-5 w-5 text-slate-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
      })])], -1)), _withDirectives(_createElementVNode("input", {
        id: "resetPassword",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => resetForm.newPassword = $event),
        type: showResetPassword.value ? 'text' : 'password',
        class: "form-search-input form-input-with-suffix",
        placeholder: "6-20位，必须包含大小写字母和数字",
        onInput: _cache[7] || (_cache[7] = $event => resetError.value = '')
      }, null, 40, _hoisted_32), [[_vModelDynamic, resetForm.newPassword]]), _createElementVNode("button", {
        type: "button",
        onClick: _cache[8] || (_cache[8] = $event => showResetPassword.value = !showResetPassword.value),
        "aria-label": showResetPassword.value ? '隐藏密码' : '显示密码',
        "aria-pressed": showResetPassword.value,
        class: "absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer text-slate-400 hover:text-slate-600 transition-colors"
      }, [showResetPassword.value ? (_openBlock(), _createElementBlock("svg", _hoisted_34, [...(_cache[30] || (_cache[30] = [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
      }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_35, [...(_cache[31] || (_cache[31] = [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      }, null, -1), _createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
      }, null, -1)]))]))], 8, _hoisted_33)])]), _createElementVNode("div", null, [_cache[37] || (_cache[37] = _createElementVNode("label", {
        for: "resetConfirmPassword",
        class: "block text-sm font-medium text-slate-700 mb-2"
      }, "确认密码", -1)), _createElementVNode("div", _hoisted_36, [_cache[36] || (_cache[36] = _createElementVNode("div", {
        class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
      }, [_createElementVNode("svg", {
        class: "h-5 w-5 text-slate-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
      })])], -1)), _withDirectives(_createElementVNode("input", {
        id: "resetConfirmPassword",
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => resetForm.confirmPassword = $event),
        type: showResetConfirmPassword.value ? 'text' : 'password',
        class: _normalizeClass(["form-search-input form-input-with-suffix", {
          'is-error': resetConfirmError.value
        }]),
        placeholder: "请再次输入新密码",
        onInput: _cache[10] || (_cache[10] = $event => resetError.value = '')
      }, null, 42, _hoisted_37), [[_vModelDynamic, resetForm.confirmPassword]]), _createElementVNode("button", {
        type: "button",
        onClick: _cache[11] || (_cache[11] = $event => showResetConfirmPassword.value = !showResetConfirmPassword.value),
        "aria-label": showResetConfirmPassword.value ? '隐藏密码' : '显示密码',
        "aria-pressed": showResetConfirmPassword.value,
        class: "absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer text-slate-400 hover:text-slate-600 transition-colors"
      }, [showResetConfirmPassword.value ? (_openBlock(), _createElementBlock("svg", _hoisted_39, [...(_cache[34] || (_cache[34] = [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
      }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_40, [...(_cache[35] || (_cache[35] = [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      }, null, -1), _createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
      }, null, -1)]))]))], 8, _hoisted_38)])]), resetError.value ? (_openBlock(), _createElementBlock("p", _hoisted_41, _toDisplayString(resetError.value), 1)) : resetConfirmError.value ? (_openBlock(), _createElementBlock("p", _hoisted_42, "两次输入的密码不一致")) : _createCommentVNode("", true), _createElementVNode("div", null, [_createElementVNode("button", {
        type: "submit",
        disabled: resetting.value,
        class: "group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-lg text-white bg-primary-700 hover:bg-primary-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-all duration-200 shadow-lg shadow-primary-500/25 hover:shadow-xl hover:shadow-primary-500/30 disabled:opacity-50 disabled:cursor-not-allowed"
      }, [resetting.value ? (_openBlock(), _createElementBlock("span", _hoisted_44, [...(_cache[38] || (_cache[38] = [_createElementVNode("svg", {
        class: "animate-spin h-5 w-5 text-primary-300",
        fill: "none",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("circle", {
        class: "opacity-25",
        cx: "12",
        cy: "12",
        r: "10",
        stroke: "currentColor",
        "stroke-width": "4"
      }), _createElementVNode("path", {
        class: "opacity-75",
        fill: "currentColor",
        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      })], -1)]))])) : _createCommentVNode("", true), _createElementVNode("span", {
        class: _normalizeClass({
          'pl-7': resetting.value
        })
      }, _toDisplayString(resetting.value ? '提交中...' : '重置密码'), 3)], 8, _hoisted_43)]), _createElementVNode("div", {
        class: "text-center"
      }, [_createElementVNode("button", {
        type: "button",
        class: "text-sm font-medium text-primary-600 hover:text-primary-500 transition-colors cursor-pointer",
        onClick: switchToLogin
      }, [...(_cache[39] || (_cache[39] = [_createElementVNode("span", {
        class: "inline-flex items-center gap-1"
      }, [_createElementVNode("svg", {
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M10 19l-7-7m0 0l7-7m-7 7h18"
      })]), _createTextVNode(" 返回登录 ")], -1)]))])])], 32)), _cache[40] || (_cache[40] = _createElementVNode("div", {
        class: "text-center"
      }, [_createElementVNode("p", {
        class: "text-xs text-slate-400"
      }, "© 2026 小到大企服平台 版权所有")], -1))])]), _cache[41] || (_cache[41] = _createStaticVNode("<div class=\"hidden lg:flex lg:flex-1 gradient-bg relative overflow-hidden\"><div class=\"absolute inset-0\"><div class=\"absolute top-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2\"></div><div class=\"absolute bottom-0 left-0 w-96 h-96 bg-white/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2\"></div></div><div class=\"relative z-10 flex flex-col justify-center px-12 py-16 text-white\"><div class=\"mb-12\"><h2 class=\"text-4xl font-bold mb-4\">您身边的财务总监</h2><p class=\"text-xl text-white/80\">专业财务管理，助力企业基业长青</p></div><div class=\"space-y-8\"><div class=\"flex items-start gap-4\"><div class=\"flex-shrink-0 w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center\"><svg class=\"w-6 h-6\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z\"></path></svg></div><div><h3 class=\"font-semibold text-lg\">业财一体化</h3><p class=\"text-white/70 text-sm mt-1\">业务与财务深度融合，数据驱动决策</p></div></div><div class=\"flex items-start gap-4\"><div class=\"flex-shrink-0 w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center\"><svg class=\"w-6 h-6\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z\"></path></svg></div><div><h3 class=\"font-semibold text-lg\">资金安全管理</h3><p class=\"text-white/70 text-sm mt-1\">全程监控资金流向，保障企业资金安全</p></div></div><div class=\"flex items-start gap-4\"><div class=\"flex-shrink-0 w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center\"><svg class=\"w-6 h-6\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z\"></path></svg></div><div><h3 class=\"font-semibold text-lg\">智能财务报表</h3><p class=\"text-white/70 text-sm mt-1\">一键生成多维度报表，精准掌控经营状况</p></div></div><div class=\"flex items-start gap-4\"><div class=\"flex-shrink-0 w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center\"><svg class=\"w-6 h-6\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z\"></path></svg></div><div><h3 class=\"font-semibold text-lg\">合规风险控制</h3><p class=\"text-white/70 text-sm mt-1\">自动合规检查，规避财税风险</p></div></div></div><div class=\"mt-16\"><p class=\"text-sm text-white/60 mb-4\">已服务超过 1000+ 企业客户</p></div></div></div>", 1))]);
    };
  }
};